import { render, staticRenderFns } from "./DemoVideoAnalysis.vue?vue&type=template&id=6879d644&scoped=true"
import script from "./DemoVideoAnalysis.vue?vue&type=script&lang=js"
export * from "./DemoVideoAnalysis.vue?vue&type=script&lang=js"
import style0 from "./DemoVideoAnalysis.vue?vue&type=style&index=0&id=6879d644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6879d644",
  null
  
)

export default component.exports